import { memo } from "react";
import { useStore } from "effector-react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { $accountBasic } from "../../../../entities/account";
import { $quote } from "../../../../entities/quote";

const useStyles = makeStyles({
  root: {
    marginBottom: 4,
  },
});

type AddressDisplayBlockProps = {
  source: "origin" | "destination";
};

export const AddressDisplayBlock = memo(
  ({ source }: AddressDisplayBlockProps) => {
    const styles = useStyles();
    const { billingAddress } = useStore($accountBasic);
    const { quote } = useStore($quote);

    const src = source === "origin" ? billingAddress : quote?.destination;

    // "123 Main St Apt 4, Tampa, FL, 33606"
    const streetLine = [src?.address, src?.address2].filter(Boolean).join(" ");
    const address = [streetLine, src?.city, src?.state, src?.postal]
      .filter(Boolean)
      .join(", ");
    if (!address) return null;

    return (
      <Typography variant="body2" color="textSecondary" className={styles.root}>
        <strong>Address:</strong> {address}
      </Typography>
    );
  },
);
